export default function translateDataLayerConsumerInsights() {
  let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    fixedOps,
    drActivity,
    trackingId,
    ...rest
  } = data;
  return {
    apiTrackingId: trackingId,
    fixedOps: fixedOps === null || fixedOps === void 0 ? void 0 : fixedOps.toString(),
    drActivity: drActivity === null || drActivity === void 0 ? void 0 : drActivity.toString(),
    ...rest
  };
}